import React from 'react';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Games from './Games';
import Contact from './Contact';

const HomePage = () => {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Games />
      <Contact />
    </>
  );
};

export default HomePage;
